import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generatePdfViewerFormField(
  params: FormFieldGenerationParams<'pdfViewer'>,
): PartialPropsOf<'pdfViewer'> {
  const props: PartialPropsOf<'pdfViewer'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  return props;
}
